import Link from 'next/link';

import { useTranslate } from '@/shared/hooks/use-translate';
import { Order2Icon } from '@/shared/ui/icons';

import { StyledNotAuthorizedWrapper } from './styled';

export const NotAuthorizedInfo = (): JSX.Element => {
    const { t } = useTranslate();

    return (
        <StyledNotAuthorizedWrapper>
            <div>
                <div className="icon">
                    <Order2Icon />
                </div>
                <div className="title">{t('Вы не авторизованы')}</div>
                <div className="link-block">
                    <span>
                        {t('Чтобы перейти к странице заказов, необходимо')}&nbsp;
                        <Link href="/sign-in">{t('войти')}</Link>
                    </span>
                </div>
            </div>
        </StyledNotAuthorizedWrapper>
    );
};
